import styled from 'styled-components';

export const ButtonContainer = styled.div`
  width: calc(100% - 65px);
  margin: ${({ theme }) => theme.spacing.l} 0 ${({ theme }) => theme.spacing.m}
    0;
`;

export const ImageInputContainer = styled.input`
  display: none;
`;
